const settings = {
  settings: {
    transOil: {
      screens: [
        {
          title: 'x-label:workflow3.settings.hydraulic trans oil.hydraulic trans oil',
          data: [
            {
              label: 'x-label:workflow3.settings.hydraulic trans oil.maint hrs to service',
              center: true
            },
            {
              label: 'x-label:workflow3.settings.hydraulic trans oil.hrs',
              num: '713.2',
              invert: true,
              center: true
            }
          ]
        },
        {
          title: 'x-label:workflow3.settings.hydraulic trans oil.screen2.hydraulic trans oil',
          data: [
            {
              label: 'x-label:workflow3.settings.hydraulic trans oil.screen2.use exmark premium transmission oil?',
              center: true,
              shrinkContent: true
            }
          ]
        },
        {
          title: 'x-label:workflow3.settings.hydraulic trans oil.screen3.reset trans oil maint hours',
          data: [
            {
              label: 'x-label:workflow3.settings.hydraulic trans oil.screen3.are you sure?'
            }
          ]
        }
      ],
      routes: {
        left: 'settings/exit',
        right: 'settings/engine-oil'
      }
    },
    engineOil: {
      screens: [
        {
          title: 'x-label:workflow3.settings.engine oil.engine oil',
          data: [
            {
              label: 'x-label:workflow3.settings.engine oil.maint hrs to service',
              center: true
            },
            {
              label: 'x-label:workflow3.settings.engine oil.hrs',
              num: '313.2',
              invert: true,
              center: true
            }
          ]
        },
        {
          title: 'x-label:workflow3.settings.engine oil.screen2.engine oil',
          data: [
            {
              label: 'x-label:workflow3.settings.engine oil.screen2.use exmark premium oil api ck4?',
              center: true,
              shrinkContent: true
            }
          ]
        },
        {
          title: 'x-label:workflow3.settings.engine oil.screen3.reset engine oil maint hours',
          data: [
            {
              label: 'x-label:workflow3.settings.engine oil.screen3.are you sure?'
            }
          ]
        }
      ],
      routes: {
        left: 'settings/hydraulic-trans-oil',
        right: 'settings/gearbox-oil'
      }
    },
    gearboxOil: {
      screens: [
        {
          title: 'x-label:workflow3.settings.deck gear box oil.deck gear box oil',
          data: [
            {
              label: 'x-label:workflow3.settings.deck gear box oil.maint hrs to service',
              center: true
            },
            {
              label: 'x-label:workflow3.settings.deck gear box oil.hrs',
              num: '313.2',
              invert: true,
              center: true
            }
          ]
        },
        {
          title: 'x-label:workflow3.settings.deck gear box oil.screen2.reset gear box oil',
          data: [
            {
              label: 'x-label:workflow3.settings.deck gear box oil.screen2.are you sure?'
            }
          ]
        }
      ],
      routes: {
        left: 'settings/engine-oil',
        right: 'settings/historical-error'
      }
    },
    historicalError: {
      screens: [
        {
          title: 'x-label:workflow3.settings.historical error.historical error',
          data: [
            {
              label: 'x-label:workflow3.settings.historical error.low oil pressure',
              center: true
            },
            {
              label: 'x-label:workflow3.settings.historical error.x',
              num: '3',
              center: true
            },
            {
              label: 'x-label:workflow3.settings.historical error.hrs',
              num: '150',
              center: true
            }
          ]
        }
      ],
      routes: {
        left: 'settings/gearbox-oil',
        right: 'settings/alarms'
      }
    },
    alarms: {
      screens: [
        {
          title: 'x-label:workflow3.settings.alarms.alarms',
          data: [
            {
              label: 'x-label:workflow3.settings.alarms.activate/deactivate',
            },
            {
              label: 'x-label:workflow3.settings.alarms.audible alarms',
            }
          ]
        }
      ],
      list: [
        {
          name: 'x-label:workflow3.settings.alarms.service air filter',
          active: true
        },
        {
          name: 'x-label:workflow3.settings.alarms.service engine oil',
          active: true
        },
        {
          name: 'x-label:workflow3.settings.alarms.service gearbox oil',
          active: true
        },
        {
          name: 'x-label:workflow3.settings.alarms.service trans oil',
          active: true
        },
        {
          name: 'x-label:workflow3.settings.alarms.system over voltage > 16v',
          active: true
        },
        {
          name: 'x-label:workflow3.settings.alarms.system voltage low',
          active: true
        },
        {
          name: 'x-label:workflow3.settings.alarms.system under voltage < 9v',
          active: true
        },
        {
          name: 'x-label:workflow3.settings.alarms.clutch over current',
          active: true
        },
        {
          name: 'x-label:workflow3.settings.alarms.clutch reset required',
          active: true
        },
        {
          name: 'x-label:workflow3.settings.alarms.engine errors',
          active: true
        },
        {
          name: 'x-label:workflow3.settings.alarms.anti stall active',
          active: true
        },
        {
          name: 'x-label:workflow3.settings.alarms.power up check',
          active: true
        }
      ],
      routes: {
        left: 'settings/historical-error',
        right: 'settings/engine-settings'
      }
    },
    engineSettings: {
      screens: [
        {
          title: 'x-label:workflow3.settings.engine settings.engine settings',
          data: [
            {
              label: 'x-label:workflow3.settings.engine settings.adjust engine speeds',
            }
          ]
        }
      ],
      list: [
        {
          name: 'lowMow',
          label: 'x-label:workflow3.settings.engine settings.set low mow speed',
          min: 1850,
          max: 2800,
          value: 2700
        },
        {
          name: 'effMow',
          label: 'x-label:workflow3.settings.engine settings.set eff mow speed',
          min: 2550,
          max: 3000,
          value: 2800
        },
        {
          name: 'maxMow',
          label: 'x-label:workflow3.settings.engine settings.set max mow speed',
          min: 2700,
          max: 3000,
          value: 3000
        },
        {
          name: 'effTrans',
          label: 'x-label:workflow3.settings.engine settings.set eff transport speed',
          min: 1800,
          max: 2300,
          value: 2000
        },
        {
          name: 'maxTrans',
          label: 'x-label:workflow3.settings.engine settings.set max transport speed',
          min: 2700,
          max: 3000,
          value: 3000
        }
      ],
      routes: {
        left: 'settings/alarms',
        right: 'settings/factory-defaults'
      }
    },
    factoryDefaults: {
      screens: [
        {
          title: 'x-label:workflow3.settings.factory defaults.factory defaults',
          data: [
            {
              label: 'x-label:workflow3.settings.factory defaults.reset',
            },
          ]
        },
        {
          title: 'x-label:workflow3.settings.factory defaults.screen2.factory defaults',
          data: [
            {
              label: 'x-label:workflow3.settings.factory defaults.screen2.are you sure?'
            }
          ]
        }
      ],
      routes: {
        left: 'settings/engine-settings',
        right: 'settings/exit'
      }
    },
    exit: {
      title: 'x-label:workflow3.settings.exit.exit',
      routes: {
        left: 'settings/factory-defaults',
        right: 'settings/hydraulic-trans-oil'
      }
    }
  }
};

export default settings;



// WEBPACK FOOTER //
// ./src/screens/data/flow3/settings.js